'use client';

import useInteractionTracker from '@blueshift-ui/telemetry/dist/hooks/use-interaction-tracker';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

function getPathWithSearch(
  pathname: null | string,
  searchParams: null | Readonly<URLSearchParams>
): string {
  const path = pathname || '/';
  const search = searchParams?.toString() ?? '';
  if (!search) return path;
  return `${path}?${search}`;
}

const AppPageViewTracker: React.FC = () => {
  const { trackEvent } = useInteractionTracker();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const prevLabelRef = useRef<null | string>(null);
  const hasTrackedInitialRef = useRef<boolean>(false);

  useEffect(() => {
    const label = getPathWithSearch(pathname, searchParams);

    if (!hasTrackedInitialRef.current) {
      hasTrackedInitialRef.current = true;
      prevLabelRef.current = label;
      void trackEvent({ action: 'loaded', category: 'page', label });
      return;
    }

    if (prevLabelRef.current !== label) {
      prevLabelRef.current = label;
      void trackEvent({ action: 'loaded', category: 'page', label });
    }
  }, [pathname, searchParams, trackEvent]);

  return null;
};

export default AppPageViewTracker;
